import { TFunction } from 'i18next';
import { DateTime } from 'luxon';

import { BasicTableColumn, CurrencyCell, DataType } from '@work4all/components';

import { DateTimeCustom } from '@work4all/utils/lib/date-utils/formatDateString';

export const getTravelReceiptsTableColumns = (
  t: TFunction
): BasicTableColumn[] => {
  return [
    {
      Header: t('COMMON.DOCUMENT_DATE'),
      accessor: 'date',
      width: 100,
      Cell: (value) => {
        const date = value.row.original['date'];
        return date
          ? DateTime.fromISO(date).toLocaleString(
              DateTimeCustom.DATE_SIMPLE_2YEAR
            )
          : '';
      },
    },
    {
      Header: t('COMMON.DOCUMENT_TYPE'),
      accessor: 'receiptKind.name',
      width: 120,
    },
    {
      Header: t('COMMON.RECEIPT_KIND_TRAVEL_COSTS'),
      accessor: 'receiptKindTravelCost.name',
      width: 150,
    },
    {
      Header: t('COMMON.PAYMENT_KIND'),
      accessor: 'paymentMethod.name',
      width: 150,
    },
    {
      Header: t('INPUTS.DESCRIPTION'),
      accessor: 'description',
      width: 300,
    },
    {
      Header: t('COMMON.CAPTURER'),
      accessor: 'travelExpenses.user.displayName',
      width: 150,
    },
    {
      Header: t('COMMON.GROSS'),
      accessor: 'expenditure',
      width: 90,
      dataType: DataType.Currency,
      Cell: CurrencyCell,
      cellParams: {
        currencyField: 'currency.name',
      },
      alignment: 'right',
    },
  ];
};
